export class StorageTip {
  title: string;
  body: string;
  _$visited?: any;
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/storageTip.ts